exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-en-404-js": () => import("./../../../src/pages/en/404.js" /* webpackChunkName: "component---src-pages-en-404-js" */),
  "component---src-pages-kz-404-js": () => import("./../../../src/pages/kz/404.js" /* webpackChunkName: "component---src-pages-kz-404-js" */),
  "component---src-templates-esg-page-js": () => import("./../../../src/templates/esg/page.js" /* webpackChunkName: "component---src-templates-esg-page-js" */),
  "component---src-templates-invest-page-js": () => import("./../../../src/templates/invest/page.js" /* webpackChunkName: "component---src-templates-invest-page-js" */)
}

